export default __webpack_public_path__ + "static/media/banner-6.c87676ea.jpg";